import NotFound from '@/views/NotFound.vue';
import Unauthorized from '@/views/Unauthorized.vue';
import UnauthorizedZoom from '@/views/UnauthorizedZoom.vue';

export default [
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    props: true,
    component: Unauthorized,
  },
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound,
  },
  {
    path: '/click/*',
    component: () => import('@/views/Tracker.vue'),
  },
  {
    path: '*',
    component: () => import('@/views/Vanity.vue'),
  },
  {
    path: '/unauthorized-zoom',
    name: 'UnauthorizedZoom',
    props: true,
    component: UnauthorizedZoom,
  },
];
